import { shareOrigin } from "@/lib/origin";
import { useState } from "react";
import { Quote, Share2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";

// The Coach's standout line from this conversation, offered as a shareable card carrying his invite link.
export default function MomentCard({ quote }) {
  const [busy, setBusy] = useState(false);
  const share = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/moments", { quote });
      const url = `${shareOrigin()}${data.path}`;
      if (navigator.share) await navigator.share({ title: "A moment from my Xcelio coach", text: `\u201c${quote}\u201d`, url });
      else { await navigator.clipboard.writeText(`\u201c${quote}\u201d ${url}`); toast("Link copied. Send it to someone who'd get it."); }
    } catch (e) {
      if (e?.name !== "AbortError") toast("Couldn't create the card. Please try again.");
    } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 rounded-xl border border-amber-200/20 bg-gradient-to-br from-amber-200/[0.06] to-transparent p-4 not-italic" data-testid="coach-moment-card">
      <p className="text-[10px] uppercase tracking-[0.2em] text-amber-200/80 flex items-center gap-1.5"><Quote className="w-3 h-3" /> A line worth keeping</p>
      <p className="font-serif italic text-base leading-snug mt-2" data-testid="coach-moment-quote">{quote}</p>
      <button onClick={share} disabled={busy} className="mt-3 inline-flex items-center gap-1.5 text-xs text-primary hover:underline" data-testid="coach-moment-share">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Share2 className="w-3.5 h-3.5" />} Share this as a card
      </button>
    </div>
  );
}
